VLW.controllers.NosVignobles = class extends VLW.controllers.Home {
	constructor(a, b) {
		super(a, b);
		this.pixi.align="cc";
		this.pixi.displacementType=VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_NOSVIGNOBLES;
		this.constructor.setStyleMenuHover("color_black");
		
		[...this.qsa("._liste li")].forEach((elt) => {
			elt.addEventListener("mouseenter", this.logoMouseEnter);
			elt.addEventListener("mouseleave", this.logoMouseLeave);
		});
		!VERSION_SMARTP && document.addEventListener("mousemove"	, this.onMousemove	, supportsPassive);
	}
	
	onMousemove(e){
		let _x = 50+50*window.mousePosition.rationMiddle.x;
		let _y = 50+50*window.mousePosition.rationMiddle.y;
		
		TweenMax.to(this.mainElementJS,.5,{perspectiveOrigin:_x+"% "+_y+"%"});
	}
	
	logoMouseEnter(e) {
		e.currentTarget.mouseEnterComplete = false;
		e.currentTarget.isMouseEnter       = true;
		TweenMax.to(e.currentTarget, .25, {opacity: 1,z:-50, onComplete: this.mouseEnterComplete, onCompleteParams: [e.currentTarget]});
		//TweenMax.to(e.currentTarget.querySelector("._hover"), .25, {x: "0%", ease: Power1.easeOut});
	}
	
	
	mouseEnterComplete(elt) {
		elt.mouseEnterComplete = true;
		TweenMax.to(elt, 1, {z: 0});
		(elt.isMouseEnter === false && this.animLeave(elt));
	}
	
	logoMouseLeave(e) {
		e.currentTarget.isMouseEnter = false;
		(e.currentTarget.mouseEnterComplete === true && this.animLeave(e.currentTarget));
	}
	
	animLeave(elt) {
		//TweenMax.to(elt.querySelector("._hover"), .5, {x                  : "101%", onComplete: (elt) => {TweenMax.set(elt.querySelector("._hover"), {x: "-101%"});}, onCompleteParams: [elt]});
	}
	introContent(){
		[...this.qsa("._liste li")].forEach((elt,i) => {
			TweenMax.fromTo(elt,1.75	,{y:50}		,{y:0,delay:0.05*i,ease:Power2.easeOut});
			TweenMax.fromTo(elt,.75		,{opacity:0},{opacity:1,delay:0.1*i,ease:Power2.easeIn});
		});
		return super.introContent();
	}
	outro(){
		document.removeEventListener("mousemove"	, this.onMousemove	, supportsPassive);
		[...this.qsa("._liste li")].forEach((elt) => {
			elt.removeEventListener("mouseenter", this.logoMouseEnter);
			elt.removeEventListener("mouseleave", this.logoMouseEnter);
			
		});
		super.outro();
	}
	loadPIXIResources(){
		if(this.mainElementJS.getAttribute("data-background")) {
			let _loader = new PIXI.loaders.Loader();
			_loader.add("image", this.getPIXIResourcesBackground());
			//_loader.add("mask", "/images/mask/nosvignobles.jpg");
			//_loader.add("displacement", "/images/d6.jpg");
			_loader.load((loader, resources) => {
				this.pixi.resources = resources;
				loader.destroy()
			});
		}
	}

};